<template>
  <div class="main-container main-banner absolute">
    <client-only>
      <el-carousel class="banner-box" :interval="5000">
        <el-carousel-item v-for="(item, index) in bgList" :key="item" :style="'background-image: url('+item.url+')'" class="banner-item">
          <div class="content" :class="'content'+(index+1)">
            <div class="text-box">
              <div class="text text1">{{ t('home.text1') }}<template v-if="index!==0"><br> {{ t('home.text2') }}</template></div>
              <div class="text text2">{{ t('home.text3') }}</div>
            </div>
            <div class="button-box">
              <template v-if="index===0">
                <button @click="dialogVisible = true">{{ t('home.btn1') }}</button>
                <button @click="dialogVisible = true">{{ t('home.btn2') }}</button>
              </template>
              <template v-if="index===1">
                <NuxtLink to="/case"><button>{{ t('home.btn3') }}</button></NuxtLink>
              </template>
            </div> 
          </div>
        </el-carousel-item>
      </el-carousel>
    </client-only>
    <register v-model="dialogVisible" />
  </div>
</template>

<script lang="ts" setup>
  import { useI18n } from 'vue-i18n'
  const { t, locale } = useI18n();
  
  useHead({
    title: t('pageTitle.home.title'),
    meta: [
      { name: 'keywords', content: t('pageTitle.home.keywords')},
      { name: 'description', content: t('pageTitle.home.description')}
    ]
  })

  const bgList = ref([
    {url: '/img/banner_01.jpg'},
    {url: '/img/banner_02.jpg'},
    {url: '/img/banner_03.jpg'}
  ])
  const dialogVisible = ref(false)

  watch(
    () => locale.value,
    () => {
      useHead({
        title: t('pageTitle.home.title'),
        meta: [
          { name: 'keywords', content: t('pageTitle.home.keywords')},
          { name: 'description', content: t('pageTitle.home.description')}
        ]
      })
    }
  );
</script>

<style scope lang="scss">
  $style1: #01a2e0;
  $style2: #2f2f2f;
  .main-banner{
    .banner-box{
      height: 100%;
      .el-carousel__container{
        height: 100%;
      }
      .banner-item{
        height: 100%;
        background: url('/public/img/banner_01.png') no-repeat top center ;
        background-size: 1920px 1022px;
        display: flex;
        align-items: center;
        .content{
          margin: -50px 0 0 70px;
          width: 100%;
          .text1{
            font-size: 70px;
            line-height: 80px;
            font-weight: bold;
          }
          .text2{
            color: #4d4d4d;
            font-size: 20px;
            line-height: 28px;
          }
          button{
            width: 270px;
            height: 85px;
            cursor: pointer;
            border-radius: 20px;
            font-size: 22px;
            border: 3px solid;
            transition: 0.5s;
          }
          &.content1{
            .text-box{
              width: 42%;
              .text1{
                position: relative;
                margin-bottom: 40px;
                &:after{
                  content: '';
                  position: absolute;
                  bottom: -25px;
                  left: 0;
                  width: 100px;
                  height: 10px;
                  background: $style1;
                  border-radius: 5px;
                }
              }
            }
            button{
              margin: 115px 54px 0 0;
              background: transparent;
              border-color: $style1;
              &:hover{
                background: $style1;
                color: #fff;
              }
            }
          }
          &.content2{
            .text-box{
              width: 30%;
              .text1{
                margin-bottom: 20px;
              }
            }
            button{
              margin-top: 85px;
              background: $style2;
              border-color: $style2;
              color: #fff;
              &:hover{
                background: transparent;
                color: $style2;
              }
            }
          }
          &.content3{
            width: 35%;//670px
            margin-top: -280px;
            .text-box{
              width: 100%;
              height: 400px;
              border-radius: 30px;
              overflow: hidden;
              background: rgba(255,0,0,0.83);
              color: #fff;
              .text{
                width: 100%;
                display: flex;
                align-items: center;
                padding: 0 0 0 40px;
              }
              .text1{
                height: 240px;
              }
              .text2{
                height: 160px;
                color: inherit;
                background: rgba(255,255,0,0.83);
                padding-right: 100px;
              }
            }
          }
        }
      }
      .el-carousel__indicators{//底部指示器
        bottom: 88px;
        .el-carousel__indicator button{
          opacity: 1;
          width: 145px;
          height: 5px;
        }
        li.is-active .el-carousel__button{
          background: #01a2e0;
        }
        
      }
    }
  }
</style>